import axios from 'axios';

const TIMEOUT = 120000;

const onRequestSuccess = (config) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  config.headers['X-TenantID'] = 'public';
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.timeout = TIMEOUT;
  return config;
};

const onResponseSuccess = (response) => {
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }
  return response;
};

const onResponseError = (err) => {
  if (err && !err.response) {
    return Promise.reject(err);
  }

  const { status = 500 } = err.response;

  if (
    status === 401 ||
    status === 504 ||
    (status === 500 && err.response.data.exception === 'io.jsonwebtoken.JwtException')
  ) {
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
    }
    if (sessionStorage.getItem('token')) {
      sessionStorage.removeItem('token');
    }
    window.location.href = '/';
  }
  return Promise.reject(err);
};

axios.interceptors.request.use(onRequestSuccess);
axios.interceptors.response.use(onResponseSuccess, onResponseError);

/*
axios.defaults.withCredentials = true;
*/

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
